export default __webpack_public_path__ + "_/images/app/ios/ios-en-1-6126462dc814159e6580e2024eaf0d521bae5212c984e1b731a5c609ba4f5294.png";